import React from 'react';
import { HomeIcon, ShieldIcon, WalletIcon, FileTextIcon, MenuIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export type TabType = 'dashboard' | 'products' | 'wallet' | 'policies' | 'profile';
interface BottomNavProps {
  activeTab: TabType;
  onChange: (tab: TabType) => void;
}
export function BottomNav({
  activeTab,
  onChange
}: BottomNavProps) {
  const tabs = [{
    id: 'dashboard',
    label: 'Home',
    icon: HomeIcon
  }, {
    id: 'products',
    label: 'Products',
    icon: ShieldIcon
  }, {
    id: 'wallet',
    label: 'Wallet',
    icon: WalletIcon
  }, {
    id: 'policies',
    label: 'Policies',
    icon: FileTextIcon
  }, {
    id: 'profile',
    label: 'More',
    icon: MenuIcon
  }] as const;
  return <div className="fixed sm:absolute bottom-0 w-full max-w-[430px] bg-white/80 backdrop-blur-xl border-t border-gray-200/50 px-4 py-2 pb-safe z-50 shadow-[0_-8px_30px_rgba(0,0,0,0.08)]" data-id="element-40">
      <div className="flex justify-between items-center" data-id="element-41">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return <button key={tab.id} onClick={() => onChange(tab.id)} className="flex flex-col items-center gap-0.5 relative w-16 py-1" data-id="element-42">
              <div className={`p-2 rounded-2xl transition-all duration-200 ${isActive ? 'bg-[#1B3B36] text-white shadow-lg shadow-emerald-900/20 scale-105' : 'text-gray-400'}`} data-id="element-43">
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2.2 : 1.8} data-id="element-44" />
              </div>
              <span className={`text-[10px] font-semibold transition-colors ${isActive ? 'text-[#1B3B36]' : 'text-gray-400'}`} data-id="element-45">
                {tab.label}
              </span>
              {isActive && <motion.div layoutId="navDot" className="absolute -bottom-1 w-1 h-1 bg-amber-500 rounded-full" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-46" />}
            </button>;
      })}
      </div>
    </div>;
}